import moment from "moment";
import { Props } from "./types/offers.types";
import { VenueOffer } from "@/services/types/venue.types";

export const getImageSrc = (type) =>
  type.includes("discount")
    ? "/icons/offer_icon.png"
    : "/icons/coupon_icon.svg";

export const getOfferText = (offer) => {
  if (offer.discount_type === "discount") {
    return `${offer.discount}% off`;
  } else {
    return `₹ ${offer.discount} off`;
  }
};

export const getUniqueOffers = (props: {
  data?: VenueOffer[];
  selectedOfferId?: string;
}): VenueOffer[] => {
  const offers = props?.data || [];

  const specialOffers: VenueOffer[] = [];
  const filteredOffers: VenueOffer[] = [];
  const nonFilteredOffers: VenueOffer[] = [];

  for (const offer of offers) {
    if (offer._id === props.selectedOfferId) {
      filteredOffers.push(offer);
    } else if (offer.special_offer) {
      specialOffers.push(offer);
    } else {
      nonFilteredOffers.push(offer);
    }
  }

  const combined = props.selectedOfferId
    ? [...specialOffers, ...filteredOffers, ...nonFilteredOffers]
    : [...filteredOffers, ...specialOffers, ...nonFilteredOffers];

  // Remove duplicates by _id
  const uniqueOffers: VenueOffer[] = Array.from(
    new Map(combined.map((item) => [item._id, item])).values()
  );

  return uniqueOffers;
};
export const showOfferTimings = (item: {
  start_time: string;
  end_time: string;
}): string => {
  const { start_time, end_time } = item;

  // Full-day offer
  if (start_time === "00:00" && end_time === "24:00") return "";

  const formatTime = (time: string): string => {
    if (time === "00:00" || time === "24:00") return "12 am";

    const [hour, minute] = time.split(":").map(Number);
    return minute > 0
      ? moment(`${hour}${minute}`, "Hmm").format("h:mm a")
      : moment(`${hour}`, "H").format("h a");
  };

  const formattedStart = formatTime(start_time);
  const formattedEnd = formatTime(end_time);

  return `${formattedStart} - ${formattedEnd}`;
};
